module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nlet hourlyRate = (resourceData || {}).value || {}\nif(hourlyRate){\nhourlyRate = utils.number.format(hourlyRate, { decimals: 2 }, 'float').formatted\n}\n%><div><%\nif(hourlyRate){\n%><%= hourlyRate %><%\n} else {\n%><%- storage.__('document.offer.scale') %><%\n}\n%></div>"
  , __filename = "components/templates/core/documents/offer/costCenters/fields/hourlyRate.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
let hourlyRate = (resourceData || {}).value || {}
if(hourlyRate){
hourlyRate = utils.number.format(hourlyRate, { decimals: 2 }, 'float').formatted
}

    ; __line = 6
    ; __append("<div>")
    ; 
if(hourlyRate){

    ; __line = 8
    ; __append(escapeFn( hourlyRate ))
    ; 
} else {

    ; __line = 10
    ; __append( storage.__('document.offer.scale') )
    ; 
}

    ; __line = 12
    ; __append("</div>")
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/core/documents/offer/costCenters/fields/hourlyRate.ejs

}